export const classCreationGoalValueName = 'classCreationGoalValue'
export const classCreationGoalDateName = 'classCreationGoalDate'
export const lessonCompletionGoalValueName = 'lessonCompletionGoalValue'
export const lessonCompletionGoalDateName = 'lessonCompletionGoalDate'
export const goal3DateName = 'goal3Date'
export const goal3TextName = 'goal3Text'
export const goal4DateName = 'goal4Date'
export const goal4TextName = 'goal4Text'
export const goal5DateName = 'goal5Date'
export const goal5TextName = 'goal5Text'
